import styled from 'styled-components';

const ColorRoutesWrapper = styled.div`
    .color-detail-card {
        background-color: red;
        color: white;
        padding: 20px;
        display: flex;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
        box-shadow: 0 6px 10px -4px rgba(0,0,0,.15);

        .opacity {
            flex: 1;
        }
    }
`;

export default ColorRoutesWrapper;